import React from "react";
import { Button, Spinner } from "react-bootstrap";

const BasicButton = ({
  onClick,
  label,
  size,
  icon,
  className,
  isLoading,
  loaderVariant,
  loaderSize,
  type,
  color,
  bg,
  variant,
}) => {
  const buttonStyle = {
    backgroundColor: bg || "transparent",
    borderColor: bg || "transparent",
    color: color ? "white" : "black",
  };

  return (
    <Button
      style={buttonStyle ?{} :buttonStyle}
      className={className}
      size={size || "sm"}
      type={type}
      onClick={onClick}
      disabled={isLoading}
      variant={variant}
    >
      {!isLoading ? (
        <>
          <div className="d-flex align-items-center justify-content-center gap-2">
            {icon} {<span style={{ fontSize: "14px" }}>{label}</span>}
          </div>
        </>
      ) : (
        <>
          <Spinner
            className="mx-1"
            size={loaderSize || "sm"}
            variant={loaderVariant || "white"}
          />
          {<span style={{ fontSize: "14px" }}>{label}</span>}...
        </>
      )}
    </Button>
  );
};

export default BasicButton;
